import { Error } from './error'
import { Success } from './success'
import { Switch } from './switch'
import { Warning } from './warning'
import { Notification } from './notification'

export const Acknowledge = { Switch, Success, Error, Notification, Warning }
